import { resetUpload } from './content'
import { createLayer } from './layers'
import { createMedia } from './media'
import { ContentTypes } from '../../constants'
import { FileUtils } from '../../utils'

const prepareUpload = (contentType) => ({
    type: 'UPLOAD_FILE##REQUEST',
    meta: { contentType },
})

/**
 * Upload file to file server
 * @param {String} contentType
 * @param {Array} files
 * @param {File} media[]
 * @param {FileServer.callbacks} callbacks
 */
const uploadToServer = (contentType, files, meta, state, callbacks) => async (dispatch) => {
    const mediaData = await Promise.all(files.map((file) => FileUtils.uploadAndBuildData(file, meta, contentType, state, callbacks)))

    return dispatch({
        type: 'UPLOAD_FILE#UPLOADED',
        payload: mediaData,
        meta: { contentType },
    })
}

const uploadFail = (contentType, message = 'Error while uploading') => ({
    type: 'UPLOAD_FILE##FAILURE',
    payload: { message },
    meta: { contentType },
})

const finishUpload = (contentType) => (dispatch) => {
    dispatch({
        type: 'UPLOAD_FILE##SUCCESS',
        meta: { contentType },
    })

    return dispatch(resetUpload(contentType))
}

const getStoreFunction = (contentType) => {
    switch (contentType) {
        case ContentTypes.LAYERS:
            return createLayer
        case ContentTypes.MEDIA:
            return createMedia
        default:
            return null
    }
}

/**
 * Action to upload any item to file server
 * @param {String} contentType
 * @param {Object} item
 * @param {FileServer.callbacks} callbacks
 */
// eslint-disable-next-line import/prefer-default-export
export const upload = (contentType, item, callbacks) => async (dispatch, getState) => {
    try {
        // If contentType has a valid value
        if (!Object.values(ContentTypes).includes(contentType)) {
            return dispatch(uploadFail(null, `contentType value is not valid ${contentType}`))
        }

        // If item is defined (and an object)
        if (!item || !(item instanceof Object)) {
            return dispatch(uploadFail(contentType, 'parameter item is undefined or not an object'))
        }

        const { file: files, ...meta } = item

        // If item contains any selected file
        if (!files) {
            return dispatch(uploadFail(contentType, 'No file selected'))
        }

        // Start upload
        await dispatch(prepareUpload(contentType))

        // Upload to file server
        await dispatch(uploadToServer(contentType, files, meta, getState(), callbacks))

        // Get current redux state
        const { content } = getState()
        const { uploaded } = content || {}

        // Check if the file was uploaded
        if (!uploaded) {
            return dispatch(uploadFail(contentType, 'File was not uploaded to the server'))
        }

        // Get the function to store the uploaded item
        const nextStep = getStoreFunction(contentType)

        if (!nextStep) {
            return dispatch(uploadFail(contentType, 'Cannot find store function'))
        }

        const storedItems = await Promise.all(uploaded.map((m) => dispatch(nextStep(m, meta))))

        // Set transaction as finished
        await dispatch(finishUpload(contentType))

        return storedItems
    } catch (e) {
        console.warn(e)
        // Notify error
        return dispatch(uploadFail(contentType, e.message))
    }
}
